module.exports = __webpack_public_path__ + "img/bogdanic.7200b488.jpg";